import { combineReducers } from 'redux';
import { AdminAccountState, AdminGroupsState, AdminUiState, AdminUsersState, CampaignsState } from 'Interfaces/Admin';
import groups from './groups';
import users from './users';
import campaigns from './campaigns';
import meta, { AdminMetaState } from './meta';
import account from './account';
import ui from './ui';

export interface AdminStateInterface {
  groups: AdminGroupsState;
  users: AdminUsersState;
  campaigns: CampaignsState;
  meta: AdminMetaState;
  account: AdminAccountState;
  ui: AdminUiState;
}

export default combineReducers<AdminStateInterface>({
  groups,
  users,
  campaigns,
  meta,
  account,
  ui,
});
